import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState, useEffect } from "react";
import { baseURL } from "../../utils/constants";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";

interface IProps {
  handleFile(file: any): void;
  cv?: string;
}

export const CvaUploader = ({ handleFile, cv }: IProps) => {
  const inputFile: any = useRef(null);
  const [localCv, setLocalCv] = useState<File | string | null>(null);

  const handleChange = (e: any) => {
    const fileUploaded = e.target.files[0];
    if (fileUploaded.size > 15000000) {
      Swal.fire({
        icon: "error",
        text: "Pdf demasiado grande, asegúrese de subir una menor a 1.5mb",
      });
      return;
    }
    setLocalCv(fileUploaded); // solo File
    handleFile(fileUploaded); // delega al padre
  };

  const handleRemove = () => {
    setLocalCv(null);
    handleFile(null);
  };

  useEffect(() => {
    if (cv && typeof cv === "string") {
      setLocalCv(cv); // si viene del padre como string (URL), lo seteamos
    }
  }, [cv]);

  return (
    <div>
      <input
        type="text"
        style={{ cursor: "pointer" }}
        className="form-control input"
        placeholder="Suba su CVA"
        onClick={() => inputFile.current?.click()}
      />
      <input
        type="file"
        ref={inputFile}
        style={{ display: "none" }}
        id="file"
        accept=".pdf,.doc"
        onChange={handleChange}
      />

      {localCv && typeof localCv === "string" && (
        <div className="mt-2 d-flex justify-content-between align-items-center">
          <a href={baseURL + localCv} download target="_blank" rel="noreferrer">
            {localCv.split("documents")[1]}
          </a>
          <button onClick={handleRemove} className="btn btn-danger btn-sm ml-2">
            Eliminar
          </button>
        </div>
      )}

      {localCv && typeof localCv !== "string" && (
        <div className="d-flex mt-2 justify-content-between align-items-center">
          <div>
            <FontAwesomeIcon icon={faCheck} />
            <span className="ml-1">{(localCv as File).name}</span>
          </div>
          <button onClick={handleRemove} className="btn btn-danger btn-sm ml-2">
            Eliminar
          </button>
        </div>
      )}
    </div>
  );
};
